import  './PressureSensorPlc.css';

export default function PressureSensorPlc({pressure, fault, islink}) {
    
    return(
       
        <div className='PressureSensorPlc'>
            {/* {islink==='Online' ? (
               <>{fault ? (<div>P: {pressure}</div>) : (<p className='PressureFault'>Авария датчика</p>)}</>
            ) : (null)}     */}
            {islink==='Online' ? (<div>P: {pressure}</div>) : (null)} 

        </div>
    )
}